import { render } from "./BoonesView.vue?vue&type=template&id=986fdfba"
import script from "./BoonesView.vue?vue&type=script&lang=js"
export * from "./BoonesView.vue?vue&type=script&lang=js"

import "./BoonesView.vue?vue&type=style&index=0&id=986fdfba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__